import { useDispatch } from 'react-redux';
import SocketProgressBar from '@/app/common/components/SocketProgressBar';
import searchVolumeApi from '@/app/KeywordResearch/api/searchVolumeApi';

type SearchVolumeProgressBarProps = {
  taskId: string;
  active: boolean;
  onComplete?: () => void;
  description?: string;
};

const SearchVolumeProgressBar = ({
  taskId,
  active,
  onComplete,
  description
}: SearchVolumeProgressBarProps) => {
  const dispatch = useDispatch();

  const handleComplete = () => {
    dispatch(searchVolumeApi.util.invalidateTags(['SearchVolumeHistory']));
    onComplete?.();
  };

  if (!taskId) return null;

  return (
    <SocketProgressBar
      channelId={taskId}
      active={active}
      onComplete={handleComplete}
      description={description}
    />
  );
};

export default SearchVolumeProgressBar;
